import React, {useEffect, useState, Fragment} from 'react';

export default (props) => {
	const [selectedProducts, setSelectedProducts] = useState();
	
	useEffect(() => {
		if(props.selectedProducts && 
			Array.isArray(props.selectedProducts) &&
			props.selectedProducts.length > 0) {
			let prodSet = [];
			props.selectedProducts.map((prod, index, array) => {
				prodSet.push(
					<li key={`crtSlctdPrd${index}`}>
						{props.capitalizeString(prod.product_name, true)}
						{prod.product_quantity && props.site.translation && ", " + props.site.translation.labels.quantity + ": " + prod.product_quantity}
					</li>
				)
			})
			setSelectedProducts(prodSet);	
		}
	}, [props.selectedProducts]);
	
	return (
		<Fragment>
			<h4>{props.site.translation && props.site.translation.cart.headings.included_products}</h4>
			<ul className="cart-info">
				{selectedProducts}
			</ul>
		</Fragment>
	)
}